import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Vue from "vue";
import FillInTheBlanks from "components/school_Homework_bank/FillInTheBlanks_bank.vue";
import Multiselect from "components/school_Homework_bank/Multiselect_bank.vue";
import TrueFalse from "components/school_Homework_bank/TrueFalse_bank.vue";
import ShortAnswer from "components/school_Homework_bank/ShortAnswer_bank.vue";
import QuestionList from "components/school_Homework_bank/QuestionList_bank.vue";
import Synthesis from "components/school_Homework_bank/Synthesis_bank.vue";
export default Vue.extend({
  name: "paper-onnline",
  components: {
    Synthesis: Synthesis,
    // ChangeType,
    TrueFalse: TrueFalse,
    ShortAnswer: ShortAnswer,
    QuestionList: QuestionList,
    Multiselect: Multiselect,
    FillInTheBlanks: FillInTheBlanks
  },
  props: {
    courseId: {
      type: String,
      default: ""
    },
    paperId: {
      type: String,
      default: ""
    },
    paperType: {
      type: String,
      default: "Paper"
    },
    faceId: {
      type: String,
      default: ""
    },
    classId: {
      type: String,
      default: ""
    },
    faceTeachStata: {
      default: ""
    }
  },
  data: function data() {
    return {
      praname: "",
      totalscore: 0,
      condition: "未开始",
      changeCondition: "开始",
      diffcult: 1,
      dialogVisible: false,
      watch: false,
      del: false,
      number: 5,
      questionList: [],
      questionInfo: {},
      checkedIds: [],
      exitIds: [],
      type: ["", "单选题", "多选题", "判断题", "填空题", "简答题", "综合体"],
      deleteId: "",
      AnswerPublishRule: 0,
      ScorePublichRule: 0,
      MultiselectRule: 0,
      FillRule: 0,
      IsTest: false,
      childQuestionList: [],
      routerUrl: "",
      //showshow: false,
      isclear: 0,
      // 用于修改题目标题
      isShowInput: false,
      // 题目数量
      QuestionCount: 0,
      tisi: "确认删除该题目？"
    };
  },
  computed: {
    slected: function slected() {
      return "\u5DF2\u9009".concat(this.checkedIds.length + this.exitIds.length, "\u9053\u9898");
    }
  },
  created: function created() {
    this.getQuestionList();
  },
  watch: {
    dialogVisible: function dialogVisible() {
      if (this.dialogVisible == false) {
        this.isclear = 1;
      }
    }
  },
  methods: {
    //返回上一级
    backone: function backone() {
      this.$router.go(-1);
    },
    // stretch() {
    //   this.show = !this.show;
    // },

    /*获取题库列表*/
    getQuestionList: function getQuestionList() {
      var _this = this;

      this.$http.post('/api/XOrg/BookMaterial/getPaperQuestionList', {
        courseId: this.courseId,
        paperId: this.paperId
      }).then(function (rst) {
        _this.questionList = rst.list;
        _this.IsTest = rst.IsTest;
        _this.praname = rst.paperName;
        _this.totalscore = rst.totalscore;
        _this.exitIds = [];
        _this.QuestionCount = rst.QuestionCount;
        rst.list.forEach(function (element) {
          _this.exitIds.push(element.QuestionId);
        });
        _this.AnswerPublishRule = rst.rule.AnswerPublishRule;
        _this.ScorePublichRule = rst.rule.ScorePublichRule;
        _this.MultiselectRule = rst.rule.MultiselectRule;
        _this.FillRule = rst.rule.FillRule;
      });
    },
    getQuestionInfoById: function getQuestionInfoById() {
      var _this2 = this;

      this.$http.post('/api/XOrg/BookMaterial/getQuestionInfoById', {
        questionId: this.courseId
      }).then(function (rst) {
        _this2.questionInfo = rst.info;
      });
    },
    //获取题目类型
    getQuestionType: function getQuestionType(QuestionType) {
      if (QuestionType == 1) {
        return "单选题";
      } else if (QuestionType == 2) {
        return "多选题";
      } else if (QuestionType == 3) {
        return "判断题";
      } else if (QuestionType == 4) {
        return "填空题";
      } else if (QuestionType == 5) {
        return "简答题";
      } else {
        return "综合题";
      }
    },
    //难度显示
    changedif: function changedif(dif) {
      if (dif == 1) {
        return "简单";
      } else if (dif == 2) {
        return "一般";
      } else {
        return "较难";
      }
    },
    goto: function goto(name, params) {
      if (name === "lectures") {
        this.$router.push({
          name: name,
          params: {
            courseId: this.courseId,
            classId: this.classId,
            faceId: this.faceId,
            classType: this.faceTeachStata
          }
        });
      } else {
        this.$router.push({
          name: name,
          params: params
        });
      }
    },
    blurQuestion: function blurQuestion(id, score, QuestionType, subCount) {
      var _this3 = this;

      var isSet = 1;

      if (QuestionType == 6) {
        if (!this.IsExcept(score, subCount)) {
          this.$message.warning("请设置可以平均赋值给予题目的分数");
          isSet = 0;
        }
      }

      if (isSet == 1) {
        if (score > 0 && score <= 100) {
          SetQuestionScore(id, score).then(function (rst) {
            if (rst.code < 0) {
              _this3.$message.warning(rst.msg);
            }
          });
        } else {
          this.$message.error("请输入0~100的分数");
        }
      }
    },
    IsExcept: function IsExcept(m, n) {
      m = parseInt(m.toString().replace(".", ""));
      n = parseInt(n.toString().replace(".", ""));

      while (m % 2 == 0 && m != 0) {
        m = m / 2;
      }

      while (m % 5 == 0 && m != 0) {
        m = m / 5;
      }

      while (n % 2 == 0 && n != 0) {
        n = n / 2;
      }

      while (n % 5 == 0 && n != 0) {
        n = n / 5;
      }

      if (n == 0) return false;
      if (n == 1 || m == 0) return true;
      return m % n == 0;
    }
  }
});